import React, {Component} from 'react';
import {Modal, Button} from 'semantic-ui-react';

class ConfirmBeforeChangePageModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': true,
    };
  }

  onCloseModalClick(saveData) {
    this.setState({'modalWasOpen': false});
    this.props.confirmClick(saveData);
  }

  render() {
    const {isOpen} = this.props;

    return (
      <Modal size='tiny' className='location-confirm-modal' open={isOpen}>
        <Modal.Header>Desea guardar los cambios?</Modal.Header>

        <Modal.Content>
          <Modal.Description>
            En caso de no guardar, los cambios realizados se perderán.
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button positive onClick={() => this.onCloseModalClick(true)}>
            Si
          </Button>
          <Button onClick={() => this.onCloseModalClick(false)}>No</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default ConfirmBeforeChangePageModal;
